<script>
export default {
  props: {
    default: { default: false }
  },

  data() {
    return {
      selected: null
    };
  },

  mounted() {
    this.selected = this.default;
  },

  render() {
    return this.$scopedSlots.default({
      selected: this.selected,
      select: value => {
        this.selected = value;
      }
    });
  }
};
</script>
